export default __webpack_public_path__ + "static/14-send-invoice-502b4c7a35ea11c3ff1d7d5c0b0562f9.png";